exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-media-advantages-card[data-v-be0a4c30]{background-color:#fff;-webkit-box-shadow:0 18px 33px 9px rgba(0,85,156,.13);box-shadow:0 18px 33px 9px rgba(0,85,156,.13)}.e-media-advantage-item[data-v-be0a4c30]{margin:20px 0}.e-media-advantage-item-avatar[data-v-be0a4c30]{display:block;height:110px;margin:10px 0}", ""]);

// exports
